import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth0 } from '@auth0/auth0-react'
import { useLocation, Link } from 'react-router-dom'
import './Header.css'
import Button from '@mui/material/Button'
import LogoutButton from '../../components/LogoutButton'
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import CloseIcon from "../../assets/images/svg/icon-close.svg";
import MenuIcon from "../../assets/images/svg/menu.svg";
import useWindowSize from "../../hook/useWindowSize";

const commonButtonSx = {
  padding: '14px 16px',
  borderRadius: '9999px',
  border: '1px solid #20C9FF',
  backgroundColor: 'transparent',
  color: '#ffffff',
  textDecoration: 'none',
  fontFamily: 'GothamBold, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '12px',
  lineHeight: '1',
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  fontVariantLigatures: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: '#ffffff',
    color: '#0A93D2',
    border: '1px solid #ffffff'
  }
}

export default function Header() {
  const location = useLocation()
  const { t } = useTranslation()
  const { isAuthenticated } = useAuth0()
  const [isMenuOpen, setMenuOpen] = useState(false)
  const windowSize = useWindowSize();

  function navClickHandler(value) {
    setMenuOpen(value)
  }

  const isResultPage = location.pathname.startsWith('/survey/result')

  if (location.pathname.startsWith('/report')) {
    return null
  }

  const showHomeAnchors =
    !location.pathname.startsWith('/survey') &&
    !location.pathname.startsWith('/ressources') &&
    !location.pathname.startsWith('/error') &&
    !location.pathname.startsWith('/legalinformation')

  return (
    <header className="header">
      <div className="header__content">
        <div className="header__logo">
          <Link to="/">
            <img src="/logo.svg" alt="Logo Digiscore" />
          </Link>
        </div>

        <div className="header__navigation">
          <ul className={`navigation ${isMenuOpen ? 'expanded' : ''}`}>
            {showHomeAnchors && (
              <>
                <li onClick={() => navClickHandler(false)}>
                  <a className="navigation__link" href={`#${t('home.why.anchor')}`}>
                    {t('home.why.menu')}
                  </a>
                </li>
                <li onClick={() => navClickHandler(false)}>
                  <a className="navigation__link" href={`#${t('home.how.anchor')}`}>
                    {t('home.how.menu')}
                  </a>
                </li>
                <li onClick={() => navClickHandler(false)}>
                  <a className="navigation__link" href={`#${t('home.companySurvey.anchor')}`}>
                    {t('home.companySurvey.menu')}
                  </a>
                </li>
                <li onClick={() => navClickHandler(false)}>
                  <a className="navigation__link" href={`#${t('home.partners.anchor')}`}>
                    {t('home.partners.menu')}
                  </a>
                </li>
                <li onClick={() => navClickHandler(false)}>
                  <a className="navigation__link" href={`#${t('home.useofdata.anchor')}`}>
                    {t('home.useofdata.menu')}
                  </a>
                </li>
                <li onClick={() => navClickHandler(false)}>
                  <a className="navigation__link" href={`#${t('home.faq.anchor')}`}>
                    {t('home.faq.menu')}
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>

        <div className="header__actions">
          <Button
            component={Link}
            to="/survey"
            variant="outlined"
            size="small"
            sx={{ ...commonButtonSx, minWidth: '230px' }}
          >
            {t('survey.list.title')}
          </Button>

          {isResultPage && (
            <Button
              type="button"
              onClick={() => window.dispatchEvent(new CustomEvent('digiscore:result:openTour'))}
              variant="outlined"
              size="small"
              sx={{ ...commonButtonSx, minWidth: '150px' }}
            >
              {t('result.options.guide')}
            </Button>
          )}

          {isAuthenticated && <LogoutButton sx={{ minWidth: '170px' }} />}

          {windowSize.width >= 640 ? (
            <div className="switcher">
              <LanguageSwitcher />
            </div>
          ) : (
            <div className="burger-menu" onClick={() => setMenuOpen(!isMenuOpen)}>
              <img alt="" src={isMenuOpen ? CloseIcon : MenuIcon} />
            </div>
          )}
        </div>
      </div>
    </header>
  )
}